<template>
  <div>
    <div class="AboutEnterprises_cont_bottom">
      <div class="AboutEnterprises_cont_bottom_item">
        <h1>{{siteInfo.num_zzsite}}</h1>
        <div class="AboutEnterprises_cont_bottom_item2">
          <span>+</span>
          <p>中转枢纽</p>
        </div>
      </div>
      <div class="AboutEnterprises_cont_bottom_item">
        <h1>{{siteInfo.num_city}}</h1>
        <div class="AboutEnterprises_cont_bottom_item2">
          <span>+</span>
          <p>全国城市</p>
        </div>
      </div>
      <div class="AboutEnterprises_cont_bottom_item3">
        <h1>{{siteInfo.num_site}}</h1>
        <div class="AboutEnterprises_cont_bottom_item4">
          <span>+</span>
          <p>营业网点</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["bannerH", "bannerP", "bannerImg"],
  data() {
    return {
      siteInfo:{}
    };
  },
  created() {
    this.siteInfo = this.commFunc.getSession('setSiteInfoByStore')
  }
};
</script>
<style scoped>
.AboutEnterprises_cont_bottom {
  display: flex;
  margin-top: 10px;
}
.AboutEnterprises_cont_bottom_item {
  margin-right: 70px;
  position: relative;
  width: 25%;
  border-right: 1px solid #ffffff;
  display: flex;
  flex-flow: row;
  align-items: center;
}
.AboutEnterprises_cont_bottom_item3 {
  margin-right: 70px;
  position: relative;
  width: 25%;
  display: flex;
  flex-flow: row;
  align-items: center;
}
.AboutEnterprises_cont_bottom_item3 p {
  width: 86px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #b30588;
  line-height: 28px;
}
.AboutEnterprises_cont_bottom_item3 h1 {
  font-size: 60px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #d00c0c;
  line-height: 84px;
}
.AboutEnterprises_cont_bottom_item3 span {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #692020;
  line-height: 24px;
}
.AboutEnterprises_cont_bottom_item4 {
  position: absolute;
  left: 161px;
  bottom: 15px;
}

.AboutEnterprises_cont_bottom_item h1 {
  font-size: 60px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #d00c0c;
  line-height: 84px;
}
.AboutEnterprises_cont_bottom_item span {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #692020;
  line-height: 24px;
}
.AboutEnterprises_cont_bottom_item p {
  width: 86px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #b30588;
  line-height: 28px;
}

.AboutEnterprises_cont_bottom_item2 {
  display: flex;
  flex-flow: column;
  padding: 20px 0 0 20px;
}
</style>
